// extracted by mini-css-extract-plugin
export default {"root":"LoadingButton_root__UDaae","loading":"LoadingButton_loading__C5EoO"};